export default "__VITE_ASSET__BKoleztN__"